import { memo, useCallback, useMemo } from 'react';
import { List, OrderedMap } from 'immutable';
import I18n from 'I18n';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import UniversalAssociationsSelectOptions from './UniversalAssociationsSelectOptions';
import EmptyState from './EmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
const UniversalAssociationsSelectSearchResults = ({
  canEdit,
  emailRecipientsIds,
  engagementOrInteractionType,
  isSearching,
  onToggleSelectAssociation,
  readOnly,
  searchResults,
  searchText,
  selectedObjectTypeId,
  shouldDisableLastAssociation,
  OptionWrapperComponent,
  refetchOptions,
  apiClient
}) => {
  const formatSearchResults = useCallback(data => {
    const contactsSection = data.find(associationRecord => (associationRecord === null || associationRecord === void 0 ? void 0 : associationRecord.get('toObjectTypeId')) === CONTACT_TYPE_ID);
    if (contactsSection) {
      const filteredOptions = contactsSection.get('associationOptionRecords').filter(option => !!(option !== null && option !== void 0 && option.get('isNewContact')));
      if (filteredOptions.size > 0) {
        data = data.withMutations(map => {
          map.forEach((val, key) => {
            if (val.get('toObjectTypeId') === CONTACT_TYPE_ID) {
              const nonNewContactOptions = val.get('associationOptionRecords').filter(option => !option.get('isNewContact'));
              if (nonNewContactOptions.size === 0) {
                map.delete(key);
              } else {
                map.set(key, val.set('associationOptionRecords', OrderedMap(nonNewContactOptions)));
              }
            }
          });
        });
        const updatedNewContactsSection = contactsSection.set('associationOptionRecords', OrderedMap(filteredOptions)).set('pluralObjectName', I18n.text('universalAssociationsSelect.searchResults.newContacts'));
        data = OrderedMap(Object.assign({
          'new-contacts-section': updatedNewContactsSection
        }, data.toObject()));
      }
    }
    return data;
  }, []);
  const renderedAssociationOptions = useMemo(() => {
    if (!searchResults) {
      return List();
    }
    const formattedSearchResults = formatSearchResults(searchResults);
    return formattedSearchResults.reduce((acc, associationRecord) => {
      /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
      return acc.concat( /*#__PURE__*/_jsx(UniversalAssociationsSelectOptions, {
        associationRecord: associationRecord,
        canEdit: canEdit,
        emailRecipientsIds: emailRecipientsIds,
        engagementOrInteractionType: engagementOrInteractionType,
        onToggleSelectAssociation: onToggleSelectAssociation,
        readOnly: readOnly,
        searchText: searchText,
        selectedObjectTypeId: selectedObjectTypeId,
        shouldDisableLastAssociation: shouldDisableLastAssociation,
        OptionWrapperComponent: OptionWrapperComponent
      }, `${associationRecord.get('pluralObjectName')}-associations-options`));
    }, List());
  }, [canEdit, emailRecipientsIds, engagementOrInteractionType, onToggleSelectAssociation, readOnly, searchResults, searchText, selectedObjectTypeId, shouldDisableLastAssociation, OptionWrapperComponent, formatSearchResults]);

  // Ensures a UniversalAssociationRecord exists for all associations search
  // and that object-specific record is populated with options
  if (!searchResults || !searchResults.size || !searchResults.first().get('associationOptionRecords').size) {
    return /*#__PURE__*/_jsx(EmptyState, {
      isSearching: isSearching,
      selectedObjectTypeId: selectedObjectTypeId,
      refetchOptions: refetchOptions,
      engagementOrInteractionType: engagementOrInteractionType,
      apiClient: apiClient
    });
  }
  return renderedAssociationOptions;
};
export default /*#__PURE__*/memo(UniversalAssociationsSelectSearchResults);

// for testing purposes
const UniversalAssociationsSelectSearchResultsWrapper = {
  default: () => UniversalAssociationsSelectSearchResults
};
export { UniversalAssociationsSelectSearchResultsWrapper };